import { deepClone } from '@/common/common.js'
import betterwe from '@/common/app-common.js'
const vipTypeOptions = {
  1: '月',
  2: '季',
  3: '年',
  4: '周',
  5: '半年',
  6: '日'
}
const rightIconList = [
  {
    title:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/8cfd642c8ec60596767f0a3882fe4008.png',
    list: [
      {
        id: 1,
        iconName: '营养方案',
        hide: true,
        icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/896aabf85665d35c91ae62dac073547a.png',
        title: '科学定制营养方案',
        important: true,
        use: null,
        canUse: null,
        data: []
      },
      {
        id: 2,
        iconName: '饮食指导',
        hide: true,
        icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/4a57aae991ab9c47f504dccfb95cd22b.png',
        title: '饮食指导',
        important: true,
        use: null,
        data: []
      },
      {
        id: 3,
        iconName: '在线答疑',
        hide: false,
        icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/612eec98c59b65b9b8f6eb7cc23ac68c.png',
        title: '营养师在线答疑',
        important: true
      }
    ]
  },
  {
    title:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e60c2db1f5d2e2535b6534b6008a861a.png',
    list: [
      {
        id: 9,
        iconName: '会员课',
        hide: false,
        icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/0e7d41d0535b23dbb7c95180fc3773de.png',
        title: ''
      }
    ]
  },
  {
    title:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/396c8b92ddc163a4204949ce7a178993.png',
    list: [
      {
        id: 4,
        iconName: '减脂工具',
        hide: false,
        icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/1bd465d104eb7d10e4ffc0d2ee10f40c.png',
        title: ''
      }
    ]
  },
  {
    title:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/baf3f13d7ae90b2107166126d089c944.png',
    list: [
      {
        id: 6,
        iconName: '商城券包',
        hide: true,
        icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/fda61802c07f7f5c4585144ff597772c.png',
        title: '甄选好物券',
        data: []
      },
      {
        id: 7,
        iconName: '商城折扣',
        hide: false,
        icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/0315422b3f08cb6ec698dd618c9a800d.png',
        title: '商城全场95折'
      }
    ]
  },
  {
    title:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/22442a581cceec4eae4e7cdbcd6a8872.png',
    list: [
      {
        id: 5,
        iconName: '抵扣券',
        hide: false,
        count: 100,
        icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/57f03287ff7cde07e9053e474749a263.png',
        title: 'betterWE明星减脂营抵扣券',
        data: []
      },
      {
        id: 8,
        iconName: '线下私教课',
        hide: false,
        icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/58451b1b0e18532ee7ddcbb290e9d63d.png',
        title: '线下健萌私教体验课 免费送'
      }
    ]
  }
]
//vip权益
const vipRightImage = [
  /* 年卡 */
  {
    id: 3,
    list: [
      {
        type: 'table',
        title:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/48b8c04d1f532a85c230698ba8b14f70.png',
        data: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/4035981b29a9e2b14b9c39bef2aaa1f6.png'
      },
      {
        type: 'feedback',
        title:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/51104100a33352b81c9bd94e80b12444.png',
        data: ''
      },
      {
        type: 'list',
        title:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e653fd6aeb51d462cb94ad882f31dc36.png',
        data: [
          {
            image:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ee04bd5856b96901d36b8e013ec9d8a6.png',
            url: '',
            title: '营养师服务',
            id: 1,
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/58cc140e294ceb786841cd4d76a8f40b.png',
            activeIcon:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/590ee7b038e40ab5c77987f7099704ba.png',
            list: [
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a7a344815d0312d4fa591b30a97c2c9c.png',
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/219a18e39ee4020ae965915b51ab1e5d.png',
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/0e0dc4d32400a183430ee79c33169526.png'
            ]
          },
          {
            image:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/fc20bd2c9b18e166b546e4f6a6c1b7d4.png',
            url: '',
            title: '会员课',
            isNew: true,
            id: 2,
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/1de4b602e6dda989926d1aabc47b9a27.png',
            activeIcon:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/7613e87012a8b79b801a83c5d0cf8775.png',
            list: [
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/81fa88c0b96932ee5246ed7b44f41024.png'
            ]
          },
          {
            image:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2f949db00c4b5f9ae96b05e8a80baebc.png',
            url: '',
            title: '减脂工具',
            id: 3,
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/0f1df09501f9b8056f7b6d89a0c6eb51.png',
            activeIcon:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d26908a4b61cb5a9b832272ce4c53792.png',
            list: [
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/33fb04f54816fbf4a08699cd81b0d9a1.png',
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/fd4f004b5bd7ea088757e82a885805d3.png',
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/317357b3cd3310764dd71316f37e62c5.png'
            ]
          },
          {
            image:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2920ab7f4c18bb1310385f3035e41054.png',
            url: '',
            title: '安心购',
            id: 4,
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a12462e4790c20a4a5f17c34d43c2700.png',
            activeIcon:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/acbd3eb143bc94321474389500139b79.png',
            list: [
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a4d9cf920fc0edae3a7f10a77026c779.png',
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e74339bab1cb8ab5c4325623ecc7f6dc.png'
            ]
          },
          {
            image:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/b8d3652ab2685cfea6eec259ad8eb1bc.png',
            url: '',
            title: '增值服务',
            id: 5,
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/057acfde218f8d016806ac2abe542806.png',
            activeIcon:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/70630640409e9eab27bb7bfec826bd2f.png',
            list: [
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a8bbbbfcc1532504029e3cc8b96a4383.png',
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a4b8efe5fffbf0abb400b5869625d77b.png'
            ]
          }
        ]
      }
    ],
    buyUrl: 'http://t.weimob.com/3pkc5', //购买链接
    betterweShopUrl: {
      pro: {
        dtid: 55,
        id: 438
      },
      pre: {
        dtid: 55,
        id: 438
      },
      test: {
        dtid: 59,
        id: 473
      },
      dev: {
        dtid: 59,
        id: 473
      }
    }, //商城链接
    consultUrl:
      'pages/image-page/index?url=https%3A%2F%2Fcdnvue.gymcity.com.cn%2Fbetterwe_1.0%2Fvue%2Fd9448b173eb97cea514a229153d9d786.jpg&title=添加陪伴官', //咨询营养师链接
    gymUrl:
      'pages/image-page/index?url=https%3A%2F%2Fcdnvue.gymcity.com.cn%2Fbetterwe_1.0%2Fvue%2Fd1d836dfa87371d5064d319a9796a9c7.jpeg&title=添加客服'
  },
  /* 季卡 */
  {
    id: 2,
    list: [
      {
        type: 'table',
        title:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/de32bfa7acdeea68ea6ba4ded7e0bea1.png',
        data: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/5635177535d333b050acae57151c4ead.png'
      },
      {
        type: 'feedback',
        title:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/51104100a33352b81c9bd94e80b12444.png',
        data: ''
      },
      {
        type: 'list',
        title:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/083a8687890b5a0d3418f3729cd5d5ba.png',
        data: [
          {
            image:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ee04bd5856b96901d36b8e013ec9d8a6.png',
            url: '',
            id: 1,
            title: '营养师服务',
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/58cc140e294ceb786841cd4d76a8f40b.png',
            activeIcon:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/590ee7b038e40ab5c77987f7099704ba.png',
            list: [
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a7a344815d0312d4fa591b30a97c2c9c.png',
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/219a18e39ee4020ae965915b51ab1e5d.png',
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/0e0dc4d32400a183430ee79c33169526.png'
            ]
          },
          {
            image:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/fc20bd2c9b18e166b546e4f6a6c1b7d4.png',
            url: '',
            title: '会员课',
            id: 2,
            isNew: true,
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/1de4b602e6dda989926d1aabc47b9a27.png',
            activeIcon:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/7613e87012a8b79b801a83c5d0cf8775.png',
            list: [
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/81fa88c0b96932ee5246ed7b44f41024.png'
            ]
          },
          {
            image:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2f949db00c4b5f9ae96b05e8a80baebc.png',
            url: '',
            id: 3,
            title: '减脂工具',
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/0f1df09501f9b8056f7b6d89a0c6eb51.png',
            activeIcon:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d26908a4b61cb5a9b832272ce4c53792.png',
            list: [
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/33fb04f54816fbf4a08699cd81b0d9a1.png',
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/fd4f004b5bd7ea088757e82a885805d3.png',
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/317357b3cd3310764dd71316f37e62c5.png'
            ]
          },
          {
            image:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2920ab7f4c18bb1310385f3035e41054.png',
            url: '',
            id: 4,
            title: '安心购',
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a12462e4790c20a4a5f17c34d43c2700.png',
            activeIcon:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/acbd3eb143bc94321474389500139b79.png',
            list: [
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e8f3d523d972e38172f09e2c58d1369f.png',
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e74339bab1cb8ab5c4325623ecc7f6dc.png'
            ]
          },
          {
            image:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/5fc4553bc979e4423ffa9115ed07f3ba.png',
            url: '',
            id: 5,
            title: '增值服务',
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/057acfde218f8d016806ac2abe542806.png',
            activeIcon:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/70630640409e9eab27bb7bfec826bd2f.png',
            list: [
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/33a85ce156a5d61f090515aad72c3d0f.png'
            ]
          }
        ]
      }
    ],
    buyUrl: 'http://t.weimob.com/530rF',
    betterweShopUrl: {
      pro: {
        dtid: 55,
        id: 439
      },
      pre: {
        dtid: 55,
        id: 439
      },
      test: {
        dtid: 59,
        id: 474
      },
      dev: {
        dtid: 59,
        id: 474
      }
    }, //商城链接
    consultUrl:
      'pages/image-page/index?url=https%3A%2F%2Fcdnvue.gymcity.com.cn%2Fbetterwe_1.0%2Fvue%2F27ae1505c9dda5953f8297de8968b489.jpg&title=添加陪伴官',
    gymUrl:
      'pages/image-page/index?url=https%3A%2F%2Fcdnvue.gymcity.com.cn%2Fbetterwe_1.0%2Fvue%2Fd1d836dfa87371d5064d319a9796a9c7.jpeg&title=添加客服'
  },
  {
    /* 月卡 */
    id: 1,
    list: [
      {
        type: 'table',
        title:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d2d69f05edb1b6e8d23a66488bf5585d.png',
        data: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/59d1f58f253b3ff38a465436408e2862.png'
      },
      {
        type: 'feedback',
        title:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/51104100a33352b81c9bd94e80b12444.png',
        data: ''
      },
      {
        type: 'list',
        title:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/07fdba6df3f9e9d82467849426974e9b.png',
        data: [
          {
            image:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ee04bd5856b96901d36b8e013ec9d8a6.png',
            url: '',
            id: 1,
            title: '营养师服务',
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/58cc140e294ceb786841cd4d76a8f40b.png',
            activeIcon:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/590ee7b038e40ab5c77987f7099704ba.png',
            list: [
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a7a344815d0312d4fa591b30a97c2c9c.png'
            ]
          },
          {
            image:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/fc20bd2c9b18e166b546e4f6a6c1b7d4.png',
            url: '',
            title: '会员课',
            id: 2,
            isNew: true,
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/1de4b602e6dda989926d1aabc47b9a27.png',
            activeIcon:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/7613e87012a8b79b801a83c5d0cf8775.png',
            list: [
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/81fa88c0b96932ee5246ed7b44f41024.png'
            ]
          },
          {
            image:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2f949db00c4b5f9ae96b05e8a80baebc.png',
            url: '',
            title: '减脂工具',
            id: 3,
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/0f1df09501f9b8056f7b6d89a0c6eb51.png',
            activeIcon:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d26908a4b61cb5a9b832272ce4c53792.png',
            list: [
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/33fb04f54816fbf4a08699cd81b0d9a1.png',
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/fd4f004b5bd7ea088757e82a885805d3.png',
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/317357b3cd3310764dd71316f37e62c5.png'
            ]
          },
          {
            image:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2920ab7f4c18bb1310385f3035e41054.png',
            url: '',
            title: '安心购',
            id: 4,
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a12462e4790c20a4a5f17c34d43c2700.png',
            activeIcon:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/acbd3eb143bc94321474389500139b79.png',
            list: [
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/b7778e671c56efbd8e938bc6daaf0e2b.png',
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e74339bab1cb8ab5c4325623ecc7f6dc.png'
            ]
          },
          {
            image:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/5fc4553bc979e4423ffa9115ed07f3ba.png',
            url: '',
            id: 5,
            title: '增值服务',
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/057acfde218f8d016806ac2abe542806.png',
            activeIcon:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/70630640409e9eab27bb7bfec826bd2f.png',
            list: [
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/33a85ce156a5d61f090515aad72c3d0f.png'
            ]
          }
        ]
      }
    ],
    buyUrl: 'http://t.weimob.com/W3QIQ',
    betterweShopUrl: {
      pro: {
        dtid: 55,
        id: 440
      },
      pre: {
        dtid: 55,
        id: 440
      },
      test: {
        dtid: 59,
        id: 475
      },
      dev: {
        dtid: 59,
        id: 475
      }
    }, //商城链接
    consultUrl:
      'pages/image-page/index?url=https%3A%2F%2Fcdnvue.gymcity.com.cn%2Fbetterwe_1.0%2Fvue%2Fb951f640fb90b56921b684f93f17ea02.jpg&title=添加陪伴官',
    gymUrl:
      'pages/image-page/index?url=https%3A%2F%2Fcdnvue.gymcity.com.cn%2Fbetterwe_1.0%2Fvue%2Fd1d836dfa87371d5064d319a9796a9c7.jpeg&title=添加客服'
  },
  {
    /* 周卡 */
    id: 4,
    list: [
      {
        type: 'table',
        title:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/071c71bca5047d1d75a790bd43884823.png',
        data: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/162cccc302f5a5267ae53e2a3bfbfd58.png'
      },
      {
        type: 'feedback',
        title:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/51104100a33352b81c9bd94e80b12444.png',
        data: ''
      },
      {
        type: 'list',
        title:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/44482aa86d9d44f89dceefed36637616.png',
        data: [
          {
            image:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ee04bd5856b96901d36b8e013ec9d8a6.png',
            url: '',
            title: '营养师服务',
            id: 1,
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/58cc140e294ceb786841cd4d76a8f40b.png',
            activeIcon:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/590ee7b038e40ab5c77987f7099704ba.png',
            list: [
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a7a344815d0312d4fa591b30a97c2c9c.png'
            ]
          },
          {
            image:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/fc20bd2c9b18e166b546e4f6a6c1b7d4.png',
            url: '',
            title: '会员课',
            id: 2,
            isNew: true,
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/1de4b602e6dda989926d1aabc47b9a27.png',
            activeIcon:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/7613e87012a8b79b801a83c5d0cf8775.png',
            list: [
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/81fa88c0b96932ee5246ed7b44f41024.png'
            ]
          },
          {
            image:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2f949db00c4b5f9ae96b05e8a80baebc.png',
            url: '',
            title: '减脂工具',
            id: 3,
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/0f1df09501f9b8056f7b6d89a0c6eb51.png',
            activeIcon:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d26908a4b61cb5a9b832272ce4c53792.png',
            list: [
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/33fb04f54816fbf4a08699cd81b0d9a1.png',
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/fd4f004b5bd7ea088757e82a885805d3.png',
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/317357b3cd3310764dd71316f37e62c5.png'
            ]
          },
          {
            image:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/bfc1648d525327b2bfdd1fd8a97c4151.png',
            url: '',
            id: 5,
            title: '增值服务',
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/057acfde218f8d016806ac2abe542806.png',
            activeIcon:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/70630640409e9eab27bb7bfec826bd2f.png',
            list: [
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/55626c6ec35a3b72a3993f2488464569.png',
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a4b8efe5fffbf0abb400b5869625d77b.png'
            ]
          }
        ]
      }
    ],
    buyUrl: 'http://t.weimob.com/xOtHl',
    betterweShopUrl: {
      pro: {
        dtid: 55,
        id: 441
      },
      pre: {
        dtid: 55,
        id: 441
      },
      test: {
        dtid: 59,
        id: 476
      },
      dev: {
        dtid: 59,
        id: 476
      }
    }, //商城链接
    consultUrl:
      'pages/image-page/index?url=https%3A%2F%2Fcdnvue.gymcity.com.cn%2Fbetterwe_1.0%2Fvue%2Ffc738a11eb96f11767bf32e4d0e3e47b.jpg&title=添加陪伴官',
    gymUrl:
      'pages/image-page/index?url=https%3A%2F%2Fcdnvue.gymcity.com.cn%2Fbetterwe_1.0%2Fvue%2Fd1d836dfa87371d5064d319a9796a9c7.jpeg&title=添加客服'
  }
]
/* 权益序号图片 */
const rightIndexImages = [
  'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/32051abffa9be09e26bc44c3f58eb2a3.png',
  'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/9f4416ef35b8a9c00b4d24d1e7b924d1.png',
  'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ec5f3d11794dd11f292ec9f630434d6a.png',
  'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/01a594835600988bb6b2603ede8cb691.png',
  'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/f04a55d87a4aa3be862ac5f9d6c13526.png'
]
/* 反馈数据 */
const feedbackData = [
  'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/dfddefc4d079ce5abe435eed4764a4a3.png',
  'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/b3af26fe23ffd19d228e607bcb091881.png',
  'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e3475e9399116c92c491c2195a527847.png',
  'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ddf73b71a8b245f32e6669d830340e48.png',
  'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/7b04ad27cc120a9b629ed307af74a510.png',
  'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/8452eebbea99c560699c295cb37c333e.png',
  'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/181be42f2e414793fe464c07859039d0.png'
]
/* 跑马灯数据 */
const paomadengData = [
  'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a6e4f8dd7ac16bdf3b34900d2751695d.png',
  'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/189022e45aeec06ae1905f0ea55dfdea.png',
  'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/47ace23f0c9f5b33add0d5cbab637dc7.png',
  'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/132909b7e58b57b0555aab8235031a34.png',
  'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a531d5422fc559fb79253a63aceb63fe.png',
  'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/fcf195f55879d4c409c16df81d4d47ac.png',
  'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d95d6a5ed48e834a0b8feaf6805773b8.png',
  'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/907f1f7c772666320eff79d16792e5f2.png'
]
/* 营养师答疑以及专属营养师客服 */
const bindConsultCoach = function (type_id) {
  let path
  vipRightImage.map((item) => {
    if (item.id == type_id) {
      path = item.consultUrl
    }
  })
  if (path) {
    betterwe.onAppPageUrlRoute(
      `/miniProgram?userName=gh_0d804ee2c21b&path=${path}`
    )
  }
}
//联系客服添加私教体验课
const bindConsultGym = function (type_id) {
  let path
  vipRightImage.map((item) => {
    if (item.id == type_id) {
      path = item.gymUrl
    }
  })
  if (path) {
    betterwe.onAppPageUrlRoute(
      `/miniProgram?userName=gh_0d804ee2c21b&path=${path}`
    )
  }
}
const vipTypeData = [
  {
    id: 3,
    name: '年卡',
    includes: [1, 2, 3, 4, 5, 6, 7, 8, 9],
    couponCount: 100, //优惠券价值
    couponId: 5
  },
  {
    id: 2,
    name: '季卡',
    includes: [1, 2, 3, 4, 6, 7, 8, 9]
  },
  {
    id: 1,
    name: '月卡',
    includes: [1, 2, 4, 6, 7, 8, 9]
  },
  {
    id: 4,
    name: '周卡',
    includes: [1, 4, 5, 8, 9],
    couponCount: 50, //优惠券价值
    couponId: 5
  }
]
//根据vip类型获取权益列表
const getRightList = function (id) {
  let _rightIconList = []
  for (let i = 0; i < vipTypeData.length; i++) {
    let item = vipTypeData[i]
    if (item.id == id) {
      _rightIconList = deepClone(rightIconList)
      _rightIconList.map((item1) => {
        item1.list = item1.list.map((item2) => {
          if (item.includes.includes(item2.id)) {
            item2.hide = false
            if (item2.id == item.couponId) {
              item2.count = item.couponCount
              item2.title = 'betterWE明星减脂营' + item.couponCount + '元抵扣券'
            }
          } else {
            item2.hide = true
          }
          return item2
        })
      })
    }
  }
  return _rightIconList
}
const courseList = [
  {
    id: 0,
    name: '所有课程',
    image: '',
    hide: true, //隐藏
    url: 'page/home/topicsDetail/topicsDetail?id=p_6433a615e4b0b2d1c40570f1&h5Url=https%3A%2F%2FapplJSmQEqs8581.h5.xiaoeknow.com%2Fp%2Fcourse%2Fbig_column%2Fp_6433a615e4b0b2d1c40570f1'
  },
  {
    id: 7,
    name: '辣妹你最行',
    image:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/3d36bfc29cfc8596da0b4b03094f93d4.png',
    url: 'page/home/columnist/columnist?id=p_6433a58de4b0f2aa7dd99f31&h5Url=https%3A%2F%2FapplJSmQEqs8581.h5.xiaoeknow.com%2Fp%2Fcourse%2Fcolumn%2Fp_6433a58de4b0f2aa7dd99f31'
  },
  {
    id: 3,
    name: '燃脂加速器',
    image:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/0d09a4678ea81d8e9e962bda712c49e7.png',
    url: 'page/home/columnist/columnist?id=p_6433a511e4b0b0bc2bd48b9c&h5Url=https%3A%2F%2FapplJSmQEqs8581.h5.xiaoeknow.com%2Fp%2Fcourse%2Fcolumn%2Fp_6433a511e4b0b0bc2bd48b9c'
  },
  {
    id: 8,
    name: '定制你的体型',
    image:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/7e765e499b4d0b6d4ff6dba91a65ef87.png',
    url: 'page/home/columnist/columnist?id=p_6433a5d1e4b0b0bc2bd48c5b&h5Url=https%3A%2F%2FapplJSmQEqs8581.h5.xiaoeknow.com%2Fp%2Fcourse%2Fcolumn%2Fp_6433a5d1e4b0b0bc2bd48c5b'
  },
  {
    id: 1,
    name: '特殊群体营养课',
    image:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/3bdbba5c2bc7bdcbedbd7a4f0f72d2b3.png',
    url: 'page/home/columnist/columnist?id=p_641c1643e4b0b0bc2bcbd2da&h5Url=https%3A%2F%2FapplJSmQEqs8581.h5.xiaoeknow.com%2Fp%2Fcourse%2Fcolumn%2Fp_641c1643e4b0b0bc2bcbd2da'
  },
  {
    id: 2,
    name: '血糖平稳剂',
    image:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/057fa5406a7b09431ccc962e528629b5.png',
    url: 'page/home/columnist/columnist?id=p_6433a4e7e4b0b2d1c4056fcc&h5Url=https%3A%2F%2FapplJSmQEqs8581.h5.xiaoeknow.com%2Fp%2Fcourse%2Fcolumn%2Fp_6433a4e7e4b0b2d1c4056fcc'
  },
  {
    id: 4,
    name: '情绪急救箱',
    image:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/4065519dfbb30ffece6150b696feac68.png',
    url: 'page/home/columnist/columnist?id=p_6433a534e4b0cf39e6b93abf&h5Url=https%3A%2F%2FapplJSmQEqs8581.h5.xiaoeknow.com%2Fp%2Fcourse%2Fcolumn%2Fp_6433a534e4b0cf39e6b93abf'
  },
  {
    id: 5,
    name: '免疫力增强',
    image:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/447f6706dea4d42f3e50f3b1fd673d34.png',
    url: 'page/home/columnist/columnist?id=p_6433a555e4b09d72378c07a2&h5Url=https%3A%2F%2FapplJSmQEqs8581.h5.xiaoeknow.com%2Fp%2Fcourse%2Fcolumn%2Fp_6433a555e4b09d72378c07a2'
  },
  {
    id: 6,
    name: '上班族小贴士',
    image:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d954c310e5ff4dc5b8af99f3e0f663ec.png',
    url: 'page/home/columnist/columnist?id=p_6433a573e4b0f2aa7dd99f1b&h5Url=https%3A%2F%2FapplJSmQEqs8581.h5.xiaoeknow.com%2Fp%2Fcourse%2Fcolumn%2Fp_6433a573e4b0f2aa7dd99f1b'
  }
]
const sportList = [
  {
    id: 0,
    name: '所有运动课程',
    image:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/447f6706dea4d42f3e50f3b1fd673d34.png',
    hide: true, //隐藏
    url: 'page/home/topicsDetail/topicsDetail?id=p_646c3471e4b0b0bc2be94917&h5Url=https%3A%2F%2FapplJSmQEqs8581.h5.xiaoeknow.com%2Fp%2Fcourse%2Fbig_column%2Fp_646c3471e4b0b0bc2be94917'
  },
  {
    id: 1,
    name: '召唤马甲线',
    image:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/059452bb673eccb5ae9c14c0cb25836e.png',
    url: 'page/home/columnist/columnist?id=p_646c35bde4b09d72379653f7&h5Url=https%3A%2F%2FapplJSmQEqs8581.h5.xiaoeknow.com%2Fp%2Fcourse%2Fcolumn%2Fp_646c35bde4b09d72379653f7'
  },
  {
    id: 2,
    name: '翘臀不粗腿',
    image:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c63228e42edfab5c4ec3e6809525fff1.png',
    url: 'page/home/columnist/columnist?id=p_646c35e3e4b0f2aa7dee4fc1&h5Url=https%3A%2F%2FapplJSmQEqs8581.h5.xiaoeknow.com%2Fp%2Fcourse%2Fcolumn%2Fp_646c35e3e4b0f2aa7dee4fc1'
  },
  {
    id: 3,
    name: '美人肩少女背',
    image:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/0511668517d2232fed42c85d7572fabe.png',
    url: 'page/home/columnist/columnist?id=p_646c35f9e4b0b2d1c41a2520&h5Url=https%3A%2F%2FapplJSmQEqs8581.h5.xiaoeknow.com%2Fp%2Fcourse%2Fcolumn%2Fp_646c35f9e4b0b2d1c41a2520'
  }
]
const BuriedData = {
  BG_SALE_VIP: 'BG_SALE_VIP', //曝光售卖vip页面
  BG_KAITONG_VIP: 'BG_KAITONG_VIP', //曝光已开通vip页面
  //vip类型曝光
  BG_VIP_TYPE: {
    3: 'BG_VIP_YEAR', //年卡
    2: 'BG_VIP_SEASON',
    1: 'BG_VIP_MONTH',
    4: 'BG_VIP_WEEK'
  },
  //点击vip类型
  CLICK_VIP_TYPE: {
    3: 'CLICK_VIP_YEAR', //年卡
    2: 'CLICK_VIP_SEASON',
    1: 'CLICK_VIP_MONTH',
    4: 'CLICK_VIP_WEEK'
  },
  //曝光开通vip上按钮
  BG_VIP_OPEN_UP: {
    3: 'BG_VIP_YEAR_OPEN_UP',
    2: 'BG_VIP_SEASON_OPEN_UP',
    1: 'BG_VIP_MONTH_OPEN_UP',
    4: 'BG_VIP_WEEK_OPEN_UP'
  },
  BG_VIP_OPEN_DOWN: {
    3: 'BG_VIP_YEAR_OPEN_DOWN',
    2: 'BG_VIP_SEASON_OPEN_DOWN',
    1: 'BG_VIP_MONTH_OPEN_DOWN',
    4: 'BG_VIP_WEEK_OPEN_DOWN'
  },
  //点击vip开通按钮上
  CLICK_VIP_OPEN_UP: {
    3: 'CLICK_VIP_YEAR_OPEN_UP',
    2: 'CLICK_VIP_SEASON_OPEN_UP',
    1: 'CLICK_VIP_MONTH_OPEN_UP',
    4: 'CLICK_VIP_WEEK_OPEN_UP'
  },
  CLICK_VIP_OPEN_DOWN: {
    3: 'CLICK_VIP_YEAR_OPEN_DOWN',
    2: 'CLICK_VIP_SEASON_OPEN_DOWN',
    1: 'CLICK_VIP_MONTH_OPEN_DOWN',
    4: 'CLICK_VIP_WEEK_OPEN_DOWN'
  },
  //曝光年卡plus
  BG_VIPPLUS_YEAR: 'BG_VIPPLUS_YEAR',
  //点击年卡plus
  CLICK_VIPPLUS_YEAR: 'CLICK_VIPPLUS_YEAR',
  //曝光权益列表
  BG_VIP_LIST: {
    1: {
      all: 'BG_VIP_DIETITIAN',
      3: 'BG_VIP_YEAR_DIETITIAN',
      2: 'BG_VIP_SEASON_DIETITIAN',
      1: 'BG_VIP_MONTH_DIETITIAN',
      4: 'BG_VIP_WEEK_DIETITIAN'
    },
    2: {
      all: 'BG_VIP_CLASS',
      3: 'BG_VIP_YEAR_CLASS',
      2: 'BG_VIP_SEASON_CLASS',
      1: 'BG_VIP_MONTH_CLASS',
      4: 'BG_VIP_WEEK_CLASS'
    },
    3: {
      all: 'BG_VIP_TOOL',
      3: 'BG_VIP_YEAR_TOOL',
      2: 'BG_VIP_SEASON_TOOL',
      1: 'BG_VIP_MONTH_TOOL',
      4: 'BG_VIP_WEEK_TOOL'
    },
    4: {
      all: 'BG_VIP_MALL',
      3: 'BG_VIP_YEAR_MALL',
      2: 'BG_VIP_SEASON_MALL',
      1: 'BG_VIP_MONTH_MALL',
      4: 'BG_VIP_WEEK_MALL'
    },
    5: {
      all: 'BG_VIP_SERVICE',
      3: 'BG_VIP_YEAR_SERVICE',
      2: 'BG_VIP_SEASON_SERVICE',
      1: 'BG_VIP_MONTH_SERVICE',
      4: 'BG_VIP_WEEK_SERVICE'
    }
  },
  //点击权益列表
  CLICK_VIP_LIST: {
    1: {
      all: 'CLICK_VIP_DIETITIAN',
      3: 'CLICK_VIP_YEAR_DIETITIAN',
      2: 'CLICK_VIP_SEASON_DIETITIAN',
      1: 'CLICK_VIP_MONTH_DIETITIAN',
      4: 'CLICK_VIP_WEEK_DIETITIAN'
    },
    2: {
      all: 'CLICK_VIP_CLASS',
      3: 'CLICK_VIP_YEAR_CLASS',
      2: 'CLICK_VIP_SEASON_CLASS',
      1: 'CLICK_VIP_MONTH_CLASS',
      4: 'CLICK_VIP_WEEK_CLASS'
    },
    3: {
      all: 'CLICK_VIP_TOOL',
      3: 'CLICK_VIP_YEAR_TOOL',
      2: 'CLICK_VIP_SEASON_TOOL',
      1: 'CLICK_VIP_MONTH_TOOL',
      4: 'CLICK_VIP_WEEK_TOOL'
    },
    4: {
      all: 'CLICK_VIP_MALL',
      3: 'CLICK_VIP_YEAR_MALL',
      2: 'CLICK_VIP_SEASON_MALL',
      1: 'CLICK_VIP_MONTH_MALL',
      4: 'CLICK_VIP_WEEK_MALL'
    },
    5: {
      all: 'CLICK_VIP_SERVICE',
      3: 'CLICK_VIP_YEAR_SERVICE',
      2: 'CLICK_VIP_SEASON_SERVICE',
      1: 'CLICK_VIP_MONTH_SERVICE',
      4: 'CLICK_VIP_WEEK_SERVICE'
    }
  },
  //曝光未开通会员Tab页开通按钮
  BG_VIP_OPEN_TAB: {
    3: 'BG_VIP_YEAR_OPEN_TAB',
    2: 'BG_VIP_SEASON_OPEN_TAB',
    1: 'BG_VIP_MONTH_OPEN_TAB',
    4: 'BG_VIP_WEEK_OPEN_TAB'
  },
  //点击未开通会员Tab页开通按钮
  CLICK_VIP_OPEN_TAB: {
    3: 'CLICK_VIP_YEAR_OPEN_TAB',
    2: 'CLICK_VIP_SEASON_OPEN_TAB',
    1: 'CLICK_VIP_MONTH_OPEN_TAB',
    4: 'CLICK_VIP_WEEK_OPEN_TAB'
  },
  //曝光营养课
  BG_VIP_CLASS_List: {
    0: 'BG_VIP_CLASS_YINGYANG_CHAKAN',
    1: 'BG_VIP_CLASS_YINGYANG_TESHU',
    2: 'BG_VIP_CLASS_YINGYANG_XUETANG',
    3: 'BG_VIP_CLASS_YINGYANG_RANZHI',
    4: 'BG_VIP_CLASS_YINGYANG_QINGXU',
    5: 'BG_VIP_CLASS_YINGYANG_MIANYI',
    6: 'BG_VIP_CLASS_YINGYANG_SHANGBAN',
    7: 'BG_VIP_CLASS_YINGYANG_LAMEI',
    8: 'BG_VIP_CLASS_YINGYANG_DINGZHI'
  },
  //点击营养课
  CLICK_VIP_CLASS_List: {
    0: 'CLICK_VIP_CLASS_YINGYANG_CHAKAN',
    1: 'CLICK_VIP_CLASS_YINGYANG_TESHU',
    2: 'CLICK_VIP_CLASS_YINGYANG_XUETANG',
    3: 'CLICK_VIP_CLASS_YINGYANG_RANZHI',
    4: 'CLICK_VIP_CLASS_YINGYANG_QINGXU',
    5: 'CLICK_VIP_CLASS_YINGYANG_MIANYI',
    6: 'CLICK_VIP_CLASS_YINGYANG_SHANGBAN',
    7: 'CLICK_VIP_CLASS_YINGYANG_LAMEI',
    8: 'CLICK_VIP_CLASS_YINGYANG_DINGZHI'
  },
  //曝光运动课
  BG_VIP_SPORT_List: {
    0: 'BG_VIP_CLASS_YUNDONG_CHAKAN',
    1: 'BG_VIP_CLASS_YUNDONG_ZHAOHUAN',
    2: 'BG_VIP_CLASS_YUNDONG_QIAOTUN',
    3: 'BG_VIP_CLASS_YUNDONG_MEIRENJIAN'
  },
  //点击运动课
  CLICK_VIP_SPORT_List: {
    0: 'CLICK_VIP_CLASS_YUNDONG_CHAKAN',
    1: 'CLICK_VIP_CLASS_YUNDONG_ZHAOHUAN',
    2: 'CLICK_VIP_CLASS_YUNDONG_QIAOTUN',
    3: 'CLICK_VIP_CLASS_YUNDONG_MEIRENJIAN'
  },
  BG_VIP_MONTH_BANNER: 'BG_VIP_MONTH_BANNER',
  CLICK_VIP_MONTH_BANNER: 'CLICK_VIP_MONTH_BANNER',
  BG_VIP_DAYI_LIJITIANJIA: 'BG_VIP_DAYI_LIJITIANJIA',
  CLICK_VIP_DAYI_LIJITIANJIA: 'CLICK_VIP_DAYI_LIJITIANJIA'
}
export {
  vipRightImage,
  rightIconList,
  vipTypeOptions,
  rightIndexImages,
  feedbackData,
  paomadengData,
  courseList,
  sportList,
  BuriedData,
  bindConsultCoach,
  bindConsultGym,
  getRightList
}
